import { defineStore } from 'pinia'
import type { LocaleCode } from '@/types/i18n'

export interface LocaleState {
  locale: LocaleCode
}

export const useLocaleStore = defineStore('locale', {
  state: (): LocaleState => ({
    locale: 'nl' as LocaleCode,
  }),

  getters: {
    currentLocale: (state): LocaleCode => state.locale,
    isEnglish: (state): boolean => state.locale === 'en',
    isDutch: (state): boolean => state.locale === 'nl',
  },

  actions: {
    setLocale(newLocale: LocaleCode) {
      this.locale = newLocale
    },

    toggleLocale() {
      this.locale = this.locale === 'nl' ? 'en' : 'nl'
    },
  },

  persist: {
    key: 'locale-preference',
    storage: localStorage,
  },
})
